__turbopack_context__.v({
  "active": "B-XOyG_active",
  "content": "B-XOyG_content",
  "contentMobile": "B-XOyG_contentMobile",
  "fadeIn": "B-XOyG_fadeIn",
  "mobileNav": "B-XOyG_mobileNav",
  "mobileNavColumn": "B-XOyG_mobileNavColumn",
  "mobileNavExpand": "B-XOyG_mobileNavExpand",
  "mobileNavItem": "B-XOyG_mobileNavItem",
  "nav": "B-XOyG_nav",
  "navItem": "B-XOyG_navItem",
  "root": "B-XOyG_root",
  "sectionTitleVisible": "B-XOyG_sectionTitleVisible",
});
